import React, {Component} from 'react'
import Form from './views'

class ApprovalForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      approval_id: '',
      username: '',
      password: '',
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(name, value) {
    this.setState({[name]: value})
  }

  handleSubmit(event) {
    event.preventDefault()

    const {
      loading,
      submitAction,
      resourceIDs,
      tokens,
    } = this.props

    return loading ? false : submitAction({
      resourceIDs,
      tokens,
      payload: this.state
    })
  }

  render() {
    const {
      loading,
      submitText = 'Next',
      errors = {},
    } = this.props

    return (
      <Form
        loading={loading}
        submitText={submitText}
        errors={errors}
        handleSubmit={this.handleSubmit}
        handleChange={this.handleChange}
        values={this.state}
      />
    )
  }
}

export default ApprovalForm



// WEBPACK FOOTER //
// ./src/approval-form/index.js